import React from 'react'
import './Footer.css'
import { Link } from "react-router-dom";

import logo2 from './image/logo2.svg'
import footer1 from './image/footer1.png'
import footer2 from './image/footer2.png'



import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";


const phoneNo = '+918299619469';

export default function Footer() {
    return (
        <>
            <div className="footer">
                <div className='container'>
                    <div className="f-upper-sec">
                        <h1>Available on the App Store & Google Play</h1>
                        <div className='f-upper-sec-img'>
                            <a className='f-link-a' href="https://apps.apple.com/in/app/partywitty/id6478442502">
                                <img src={footer1} alt="" />
                            </a>
                            <a className='f-link-a' href="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                <img src={footer2} alt="" />
                            </a>
                        </div>
                    </div>
                    <div className='f-lower-sec'>
                        <div className='f-logo'>
                            <img src={logo2} alt="" />
                            <div className='f-logo-icon-social'>
                                <a className='f-link-a' href="https://www.facebook.com/party.witt?mibextid=ZbWKwL">
                                    <div className='f-logo-icon'>
                                        <FaFacebookF />
                                    </div>
                                </a>
                                <a href={`https://wa.me/${phoneNo}`}>
                                  <div className='f-logo-icon'>
                                    <BsWhatsapp />
                                  </div>
                                </a>
                                <a className='f-link-a' href="https://www.linkedin.com/company/partywitty/posts/?feedView=all">
                                    <div className='f-logo-icon'>
                                        <FaLinkedinIn />
                                    </div>
                                </a>
                                <a className='f-link-a' href="https://www.instagram.com/partywitty_?igshid=NzZhOTFlYzFmZQ%3D%3D">
                                    <div className='f-logo-icon'>
                                        <FaInstagram />
                                    </div>
                                </a>


                            </div>
                        </div>
                        <div className='f-links-sec'>
                            <div className="f-links">
                                <h4>Menu</h4>
                                <ul>
                                    <Link className='f-link-a' to="/PartyWitty-Home">
                                    <li>Home</li>
                                    </Link>
                                    <Link className='f-link-a' to="/party-witty-aboutus">
                                        <li>About us</li>
                                    </Link>
                                    <Link className='f-link-a' to="/services">
                                        <li>services</li>
                                    </Link>
                                    <Link className='f-link-a' to="/blog">
                                        <li>blogs</li>
                                    </Link>
                                    <Link className='f-link-a' to="/our-contact-page">
                                        <li>contact us</li>
                                    </Link>
                                </ul>
                            </div>
                            <div className="f-links">
                                <h4>Collections</h4>
                                <ul>
                                    <Link className='f-link-a' to="/party-packages-delhi-ncr-view-all">
                                        <li>Packages</li>
                                    </Link>
                                    <Link className='f-link-a' to="/book-a-table-delhi-ncr-view-all">
                                        <li>Venues</li>
                                    </Link>
                                    <Link className='f-link-a' to="/event-delhi-ncr-view-all">
                                        <li>Events</li>
                                    </Link>
                                    <Link className='f-link-a' to="/artist-view-all">
                                        <li>Artist</li>
                                    </Link>
                                    <li>Catering</li>
                                </ul>
                            </div>
                            <div className="f-links">
                                <h4>Agreements</h4>
                                <ul>
                                    <Link className='f-link-a' to="/club-agreement">
                                        <li>Club Agreement</li>
                                    </Link>
                                    <Link className='f-link-a' to="/artist-agreement">
                                        <li>ARTIST AGREEMENT</li>
                                    </Link>
                                    <Link className='f-link-a' to="/refund-policy">
                                        <li>REFUND & CANCELLATION
                                            POLICY</li>
                                    </Link>
                                    <Link className='f-link-a' to="/privacy-policy">
                                        <li>PRIVACY POLICY</li>
                                    </Link>
                                    <Link className='f-link-a' to="/term-conditions-policy">
                                        <li>TERMS & CONDITION</li>
                                    </Link>
                                </ul>
                            </div>
                            <div className="f-links">
                                <h4>Partner with</h4>
                                <ul>
                                    <Link className='f-link-a' href="/as-an-artist">
                                        <li>AS AN ARTIST</li>
                                    </Link>
                                    <Link className='f-link-a' href="/Product-Pricing">
                                        <li>AS A BUSINESS</li>
                                    </Link>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='f-copyright'>
                            <p>Terms & Conditions Privacy Policy</p>
                            <p>© AMIRAG HOSPITALITY PVT. LTD., All Right Reserved</p>
                            <p>Partywitty.com</p>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
